<template>
  <div>
    <ui-spinner v-if="loading.view == true"></ui-spinner>
    <div v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Identificador *</label>
            <input v-model="form.identifier" type="text" class="form-control form-control-sm" />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Placa</label>
            <input v-model="form.license_plate" type="text" class="form-control form-control-sm" />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Tipo</label>
            <input v-model="form.type" type="text" class="form-control form-control-sm" />
          </div>
          <div class="form-group">
            <label for="" class="form-label">Conductor</label>
            <InputSelect v-model="form.driver" :options="containers.drivers" label="nombreCompleto"> </InputSelect>
          </div>
          <div class="form-group">
            <label for="" class="form-label">Propiedad</label>
            <div>
              <label for="radioPropertyAjeno">
                <input id="radioPropertyAjeno" type="radio" v-model="form.property" :value="0" />
                Ajeno
              </label>
              <label for="radioPropertyPropio" class="ml-3">
                <input id="radioPropertyPropio" type="radio" v-model="form.property" :value="1" />
                Propio
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for="" class="form-label">Estado</label>
            <select v-model="form.state" class="form-control form-control-sm">
              <option :value="true">Activo</option>
              <option :value="false">Inactivo</option>
            </select>
          </div>
          <div class="form-group text-right">
            <button class="btn btn-sm btn-outline-success" :disabled="loading.save" @click="onNew">
              Nuevo
            </button>
            <button class="ml-2 btn btn-sm btn-primary" :disabled="loading.save" @click="onSave">
              Guardar
            </button>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
                <tr class="text-center align-middle">
                  <th style="width: 100px"></th>
                  <th>Identificador</th>
                  <th>Placa</th>
                  <th>Tipo</th>
                  <th>Conductor</th>
                  <th>Contacto</th>
                  <th>Estado</th>
                  <th>Propiedad</th>
                  <th>UC</th>
                  <th>UM</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in containers.vehiculos" :key="item.idVehiculo" class="align-middle text-center">
                  <td>
                    <template v-if="item.origen != 0">
                      <button class="btn btn-xs btn-icon btn-light-warning" @click="onEdit(item)">
                        <span class="fa fa-fw fa-pencil-alt"></span>
                      </button>
                      <button class="btn btn-xs btn-icon btn-light-danger ml-2" @click="onDelete(item)">
                        <span class="fa fa-fw fa-trash-alt"></span>
                      </button>
                    </template>
                  </td>
                  <td>{{ item.identificador }}</td>
                  <td>{{ item.placa || "" }}</td>
                  <td>{{ item.tipo || "" }}</td>
                  <td>{{ item.conductor || "" }}</td>
                  <td>{{ item.telefono1 || "" }}</td>
                  <td>{{ item.estado == 1 ? "Activo" : "Inactivo" }}</td>
                  <td>{{ item.propiedad == 1 ? "Propio" : "Ajeno" }}</td>
                  <td>{{ item.usuarioCreador }}</td>
                  <td>{{ item.usuarioModif }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputSelect from "../../../modules/shared/components/InputSelect.vue";
export default {
  layout: "app",
  components: { InputSelect },
  data() {
    return {
      form: {
        identifier: "",
        license_plate: "",
        type: "",
        driver: "",
        property: 1,
        state: true,
      },
      loading: {
        view: true,
        save: false,
      },
      containers: {
        id: null,
        vehiculos: [],
        drivers: [],
      },
    };
  },
  async created() {
    const vm = this;

    let {
      data: { content },
    } = await vm.axios.get("/mantenimiento/vehiculos");

    vm.containers.vehiculos = content.vehiculos;
    vm.containers.drivers = content.conductores;

    vm.loading.view = false;
  },
  methods: {
    onSave() {
      let vm = this;
      const form = { ...vm.form };

      let fd = {
        identifier: String(form.identifier).trim(),
        license_plate: String(form.license_plate || "").trim(),
        type: String(form.type || "").trim(),
        driver: form.driver ? form.driver.idPersona : null,
        property: form.property,
        state: form.state ? 1 : 0,
        _method: "POST",
      };

      if (!fd.identifier) {
        return vm.$swal.fire("", "Completa los campos obligatorios (*)", "warning");
      }

      vm.loading.save = true;

      let endpoint = "/mantenimiento/vehiculos";

      if (vm.containers.id) {
        endpoint = `/mantenimiento/vehiculos/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
        .post(endpoint, fd)
        .then((response) => {
          if (vm.containers.id) {
            vm.containers.vehiculos = vm.containers.vehiculos.map((vehicle) => {
              if (vehicle.idVehiculo == vm.containers.id) {
                return {
                  ...vehicle,
                  identificador: fd.identifier,
                  placa: fd.license_plate || "",
                  tipo: fd.type || "",
                  conductor: form.driver?.nombreCompleto || "",
                  telefono1: form.driver?.telefono1 || "",
                  estado: fd.state ? 1 : 0,
                  propiedad: fd.property == 1 ? "Propio" : "Ajeno",
                  idConductor: fd.driver || "",
                  usuarioModif: vm.$store.state.user.codigo,
                };
              } else {
                return vehicle;
              }
            });
          } else {
            // onStore
            vm.containers.vehiculos.push({
              idVehiculo: response.data.content.id,
              identificador: fd.identifier,
              placa: fd.license_plate || "",
              tipo: fd.type || "",
              conductor: form.driver?.nombreCompleto || "",
              telefono1: form.driver?.telefono1 || "",
              estado: fd.state ? 1 : 0,
              propiedad: fd.property == 1 ? "Propio" : "Ajeno",
              idConductor: fd.driver || "",
              usuarioCreador: vm.$store.state.user.codigo,
            });

            vm.onNew();
            // vm.containers.id = response.data.content.id;
          }

          vm.$toast.fire(response.data.message, "", "success");
        })
        .catch(({ response = {} }) => {
          if (response?.errorsForHumans) {
            vm.$swal.fire("", response.errorsForHumans, "warning");
          }
        })
        .finally(() => {
          vm.loading.save = false;
        });
    },
    onEdit(item) {
      let vm = this;

      vm.containers.id = item.idVehiculo;
      vm.form.identifier = item.identificador;
      vm.form.license_plate = item.placa;
      vm.form.type = item.tipo;

      vm.form.driver = item.idConductor ? vm.containers.drivers.find((driver) => driver.idPersona == item.idConductor) : null;

      vm.form.property = item.propiedad;
      vm.form.state = item.estado ? true : false;
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire("", "¿Seguro que desea eliminar este item?");

      if (response.value) {
        vm.loading.save = true;

        vm.axios
          .delete(`/mantenimiento/vehiculos/${pItem.idVehiculo}`)
          .then((response) => {
            let tempRegistros = [...vm.containers.vehiculos];
            vm.containers.vehiculos = tempRegistros.filter((item) => item.idVehiculo != pItem.idVehiculo);
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.save = false;
          });
      }
    },
    onNew() {
      let vm = this;
      vm.containers.id = null;
      vm.form.identifier = "";
      vm.form.license_plate = "";
      vm.form.type = "";
      vm.form.driver = null;
      vm.form.state = true;
      vm.form.property = 1;
    },
  },
};
</script>
